import { connect } from "react-redux";
import {
	Edit,
	CardActions,
	ListButton,
	RefreshButton,
	translate
} from "react-admin";
import React from "react";
import { change } from "redux-form";
import UserForm from "./UserForm";

const UserTitle = ({ translate, record }) => {
	return (
		<span>
			{`${translate("user.user")}`}{" "}
			{record ? `"${record.email} ${record.provider}"` : ""}
		</span>
	);
};

const Title = translate(UserTitle);

const Actions = ({ basePath, data, resource }) => (
	<CardActions>
		<ListButton basePath={basePath} />
		{/* <DeleteButton basePath={basePath} record={data} resource={resource} /> */}
		<RefreshButton />
	</CardActions>
);

const UserEdit = props => (
	<Edit actions={<Actions />} title={<Title />} {...props}>
		<UserForm isEdit routes={props.routes} changeValueField={props.changeValueField} />
	</Edit>
);

const mapStateToProps = state => ({
	routes: state.admin.resources
});

const mapDispatchToProps = (dispatch) => ({
	changeValueField: (field, value) => dispatch(change("record-form", field, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserEdit);



// WEBPACK FOOTER //
// ./src/components/user/UserEdit.js